'use strict';

import React from 'react';
import {Link,browserHistory} from 'react-router';
import Header from './HeaderComponent';
import API from 'sources/API';
import BusinessActions from 'actions/BusinessActions';
import BusinessStore from 'stores/BusinessStore';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';

require('styles/Businesses.scss');

class BusinessesComponent extends React.Component {
  constructor(props) {
    super(props);
    let businessStore = BusinessStore.getState()
    this.state = {
      businesses: businessStore.businessList,
      user: {}
    }
    this.goto = this.goto.bind(this)
    this.gotoStore = this.gotoStore.bind(this)
    this.onGoBack = this.onGoBack.bind(this)
    this.onBusinessChange = this.onBusinessChange.bind(this)
    this.onUserChange = this.onUserChange.bind(this)
  }
  gotoStore(business_id){
    browserHistory.push(`/business/${business_id}`)
  }
  goto(path){
    browserHistory.push(path)
  }
  onGoBack(){
    browserHistory.goBack()
  }
  componentDidMount() {
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }
    
    BusinessStore.listen(this.onBusinessChange)
    UserStore.listen(this.onUserChange)

    BusinessActions.clearBusiness()
    UserActions.fetchUser(this.props.params.id)
    BusinessActions.fetchBusinessList(this.props.params.id)

    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    BusinessStore.unlisten(this.onBusinessChange)
    UserStore.unlisten(this.onUserChange)
  }
  onBusinessChange(business){
    this.setState({
      businesses: business.businessList
    })
  }
  onUserChange(state){
    this.setState({
      user: state.user
    })

    if(state.user && state.user.name){
      let userName = state.user.name;
      let sharePic = state.user.avatar;
      window.wx.ready(()=>{
        window.wx.onMenuShareTimeline({
          title: `${userName}的店铺`,
          link: location.href,
          imgUrl: encodeURI(sharePic)
        });
        window.wx.onMenuShareAppMessage({
          title: `${userName}的店铺`,
          desc: `分享${userName}的店铺,发现有趣的地方`,
          link: location.href,
          imgUrl: encodeURI(sharePic),
          type: 'link'
        });
      });

      let title = `${userName}的店铺`;
      let desc = `${state.user.summary?state.user.summary.substring(0,150):''}`;
      let keywords = `${userName} ${state.user.weibo} ${state.user.wechat_name} ${state.user.website} ${state.user.location}`;
      window.changeMetaForSEO(title,desc,keywords);
    }
  }
  handleTextChange(event) {
    let state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }
  render(){
  	return (
  	  <div className="Businesses-component">
        <div className="row align-center header">
          <a className="columns text-white text-left small-3 pl-15" onClick={this.onGoBack}>返回</a>
          <span className="title columns small-6 text-center">
            {this.state.user?this.state.user.name:null}的店铺
          </span>
          <Link className='pr-15 columns small-3 text-white text-right' to='/new/business'>添加</Link>
        </div>
        <div className="content">
          {this.state.businesses.map(business => {
            return (
            <div onClick={this.gotoStore.bind(null,business._id)} key={business._id} className="business-item">
              <div className="left">
                <img src={business.small_avatar} />
              </div>
              <div className="right">
                <span>{business.name}</span>
                <p className="desc">{business.summary}</p>
              </div>
              <div className="clear"></div>
            </div>)
          })}
         {!this.state.businesses.length?<div className="text-gray width-all height-100 lh-100 fz-14 text-center">~还没有属于自己的店铺~</div>:''}
         <div className="footer"></div>
        </div>
  	  </div>
  	);
  }
}
 
BusinessesComponent.displayName = 'BusinessesComponent';

export default BusinessesComponent;



// WEBPACK FOOTER //
// ./src/components/BusinessesComponent.js